import React, { useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import TemplateDetails from '../ModalCotent/EmailTemplate/TemplateDetails'
import { EmailTemplateResp } from 'types/globalTypes'
import CustomModalFooter from 'components/global/CustomModalFooter'
import {
  EventEmailTemplatePayload,
  EventEmailTemplateResp,
} from 'types/event/eventStep5'
import EmailBody from '../ModalCotent/EmailTemplate/EmailBody/EmailBody'

interface EmailTemplateModalProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
  organizationId: string
  referenceId: string
  reference: 'event' | 'league' | 'organization' | 'class'
  data: EventEmailTemplateResp | undefined
}

const EmailTemplateModal: React.FC<EmailTemplateModalProps> = ({
  openModal,
  closeModal,
  organizationId,
  referenceId,
  reference,
  data,
}) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [payload, setPayload] = useState<EventEmailTemplatePayload>()
  const { form, handleSubmit } = useFormSubmit()

  const hanldeClose = () => {
    closeModal(false)
  }

  const hanldeBack = () => {
    setCurrentStep(0)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom
        closeModal={hanldeClose}
        title="Add template"
        width={700}
        footer={
          <CustomModalFooter
            multibutton={currentStep == 1 ? true : false}
            btnText={
              currentStep === 1
                ? 'Back, Save Template'
                : 'Confirm & Customize email'
            }
            btnAlignment={currentStep === 1 ? 'justify-between' : 'justify-end'}
            btnType="primary"
            closeModal={hanldeBack}
            onSubmit={handleSubmit}
          />
        }
      >
        {currentStep === 0 && (
          <TemplateDetails
            form={form}
            data={data}
            payload={payload}
            setPayload={setPayload}
            setCurrentStep={setCurrentStep}
            reference={reference}
          />
        )}
        {currentStep === 1 && (
          <EmailBody
            form={form}
            data={data}
            payload={payload}
            organizationId={organizationId}
            referenceId={referenceId}
            reference={reference}
            closeModal={closeModal}
          />
        )}
      </CustomModal>
    </>
  )
}

export default EmailTemplateModal
